import { Component, Inject } from '@angular/core';
import { Http } from '@angular/http';

type Action = 'confirm' | 'cancel' | 'call_back' | 'transfer';

@Component({
  selector: 'execute-action',
  template: require('./execute-action.component.html'),
  styles: [require('./execute-action.component.scss')],
})
export class ExecuteActionComponent {
  public isLoading: boolean;

  public actions: Action[];

  constructor(
    @Inject('$state') private $state,
    private http: Http,
  ) {}

  ngOnInit() {
    this.http.get(`/api/v2/hospital_booking/notification_action/available_actions`, { search: { actionToken: this.$state.params.t } }).subscribe((response) => {
      this.actions = response.json();
    }, () => {
      this.$state.go('hospital_booking.action_feedback', { action: 'unavailable' });
    });
  }

  executeAction(action: Action) {
    this.isLoading = true;

    this.http.post('/api/v2/hospital_booking/notification_action', {
      actionToken: this.$state.params.t,
      appointmentAction: action,
    }).subscribe(() => {
      this.$state.go('hospital_booking.action_feedback', { action: action });
    }, () => {
      this.$state.go('hospital_booking.action_feedback', { action: 'unavailable' });
    });
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/hospital-booking/execute-action/execute-action.component.ts